import React, { useMemo } from 'react';
import { VisitorBooking } from "../data/visitor-booking-service";
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';

export function VisitorParkingSpaceLabel(props: Props) {
  const {booking} = props;

  const label = useMemo(() => {
    const amParkingSpaceLabel = booking.amParkingSpaceLabel;
    const pmParkingSpaceLabel = booking.pmParkingSpaceLabel;

    if (amParkingSpaceLabel || pmParkingSpaceLabel) {
      if (amParkingSpaceLabel === pmParkingSpaceLabel) {
        return amParkingSpaceLabel;
      }

      if (amParkingSpaceLabel && !pmParkingSpaceLabel) {
        return amParkingSpaceLabel + '(AM)';
      }

      if (!amParkingSpaceLabel && pmParkingSpaceLabel) {
        return pmParkingSpaceLabel + '(PM)';
      }

      if (amParkingSpaceLabel !== pmParkingSpaceLabel) {
        return `${amParkingSpaceLabel} (AM) | ${pmParkingSpaceLabel} (PM)`
      }
    }

    return undefined;
  }, [booking.amParkingSpaceLabel, booking.pmParkingSpaceLabel]);

  if (!label) return null;

  return (
    <>
      {label && <BodyVerySmall weight={400} colour={Colours.darkGrey}>{label}</BodyVerySmall>}
    </>
  )
}

interface Props {
  booking: VisitorBooking;
}
